exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-row-container{display:flex;justify-content:center;align-items:center}.v-input__control{overflow:hidden!important;text-overflow:ellipsis!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/FormTratta.vue?vue&type=style&index=0&lang=scss&
// module id = 762
// module chunks = 0